import { getTechnicalAssistanceModule } from '../../config/apiSinToken'

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener todos los solicitantes de asistencia tecnica de un formularios
 * Fecha: 20-01-2023
 */
export const getTechnicalAssistanceApplicant = async (params) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceApplicant/listByForm/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener las asistencias tecnicas recibidas de un formulario
 * Fecha: 20-01-2023
 */
export const getTechnicalAssistanceReceived = async (params) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceReceived/list/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener las mipymes que tiene formulario pre-elegible
 * Fecha: 31-01-2023
 */
export const getMIPYMESElegibleForTechnicalAssistance = async (params) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/MiPymes/EligibleForTechnicalAssistance/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener las mipymes que tienen un credito asignado
 * Fecha: 31-01-2023
 */
export const getMIPYMESElegibleForCapacityBuilding = async (params) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/MiPymes/EligibleForCapacityBuilding/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener los proyectos que tiene formulario pre-elegible
 * Fecha: 31-01-2023
 */
export const getProjectsElegibleForTechnicalAssistance = async (params) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/Projects/EligibleForTechnicalAssistance/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener los proyectos que tienen un credito asignado
 * Fecha: 31-01-2023
 */
export const getProjectsElegibleForCapacityBuilding = async (params) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/Projects/EligibleForCapacityBuilding/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener el presupuesto
 * Fecha: 02-02-2023
 */
export const getTechnicalAssistanceBudget = async (params) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceBudget/list-view/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener las actividades
 * Fecha: 03-02-2023
 */
export const getTechnicalAssistanceImplementationActivities = async (
  params,
) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/ImplementationActivities/list/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener las actividades
 * Fecha: 03-02-2023
 */
export const getIndigenousCommunities = async (params) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/IndigenousCommunities/list/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener las actividades
 * Fecha: 03-02-2023
 */
export const getBudgetCategories = async () => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/DataFields/list-fields?formType=AsistenciaTecnica&section=2&question=4`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener las categorias que ha llenado en el presupuesto
 * Fecha: 03-02-2023
 */
export const getTechnicalAssistanceBudgetCategories = async (params) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceBudget/list/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener la data de una categoria
 * Fecha: 14-02-2023
 */
export const getTechnicalAssistanceBudgetFindCategory = async ({
  idForm,
  idCategory,
}) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceBudget/find-category/${idForm}/${idCategory}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener los Applied Studies
 * Fecha: 23-02-2023
 */
export const getAppliedStudies = async (params) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/AppliedStudies/GetAppliedStudies?IdTechnicalAssistanceAnswer=${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener los Provider List
 * Fecha: 13-03-2023
 */
export const getProviderList = async (params) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/ProviderList/list/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener los GetAttachedDocuments
 * Fecha: 23-03-2023
 */
export const GetAttachedDocuments = async ({ IdForm, RelatedFormField }) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/AttachedDocuments/GetAttachedDocuments?IdForm=${IdForm}&RelatedFormField=${RelatedFormField}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para verificar si la ifi tiene desembolso
 * Fecha: 24-03-2023
 */
export const GetIfiHasDisbursement = async (param) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/IFIS/IfiHasDisbursement/idIfi?idIfi=${param}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener la informacion de un formulario
 * Fecha: 28-03-2023
 */
export const GetTechnicalAssistanceAnswers = async (param) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceAnswers/find/${param}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener el full form
 * Fecha: 21-04-2023
 */
export const getTechnicalAssistanceFullForm = async (param) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceAnswers/find/getTechnicalAssistanceFullForm/${param}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener la validacion de las actividades
 * Fecha: 04-04-2023
 */
export const getValidationImplementationActivity = async (
  id,
  StartExecutionPeriod,
  EndExecutionPeriod,
) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceAnswers/ImplementationActivity/Validation/${id}?StartExecutionPeriod=${StartExecutionPeriod}&EndExecutionPeriod=${EndExecutionPeriod}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener la  solicitud de no objecion de
 * Fecha: 11-08-2023
 */
export const getRequestNoObjection = async (param) => {
  const data = await getTechnicalAssistanceModule(
    `api/v1/TechnicalAssistanceAnswers/AttachedDocuments/RequestNoObjection?idForm=${param}`,
  )
  return data
}
